var _defs, _g, _path, _path2, _path3, _g2, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarketaccelerationgoallogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    zoomAndPan: "magnify",
    viewBox: "0 0 810 809.999993",
    height: 1080,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "e57e758550"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 81 110.59375 L 729 110.59375 L 729 699.742188 L 81 699.742188 Z M 81 110.59375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "815f2666ac"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 148.5 110.59375 L 661.5 110.59375 C 698.777344 110.59375 729 140.816406 729 178.09375 L 729 631.90625 C 729 669.183594 698.777344 699.40625 661.5 699.40625 L 148.5 699.40625 C 111.222656 699.40625 81 669.183594 81 631.90625 L 81 178.09375 C 81 140.816406 111.222656 110.59375 148.5 110.59375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7421da0fa5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 184.574219 350.519531 L 374.773438 350.519531 L 374.773438 540.722656 L 184.574219 540.722656 Z M 184.574219 350.519531 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: 7202837230
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 279.671875 350.519531 C 227.152344 350.519531 184.574219 393.097656 184.574219 445.621094 C 184.574219 498.144531 227.152344 540.722656 279.671875 540.722656 C 332.195312 540.722656 374.773438 498.144531 374.773438 445.621094 C 374.773438 393.097656 332.195312 350.519531 279.671875 350.519531 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e57e758550)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#815f2666ac)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffd154",
    d: "M 81 110.59375 L 729 110.59375 L 729 699.109375 L 81 699.109375 Z M 81 110.59375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(3.191534, 0.000000000000008302, -0.000000000000008246, 3.17, 486.874755, 559.914304)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 2.500588 2.50017 L 41.206501 2.50017 ",
    stroke: "#397da2",
    strokeWidth: 5,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(3.164296, 0, 0, 3.17, 280.059246, 438.081502)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M -0.000206195 2.500413 L 101.687365 2.500413 ",
    stroke: "#397da2",
    strokeWidth: 5,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(3.164296, 0, 0, 3.17, 280.059246, 438.081502)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 91.688102 -5.000325 L 101.687365 2.500413 L 91.688102 9.999919 ",
    stroke: "#397da2",
    strokeWidth: 5,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7421da0fa5)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7202837230)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(3.157666, 0, 0, 3.157666, 184.573645, 350.520998)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 30.116623 -0.00046462 C 13.484232 -0.00046462 0.000181569 13.483586 0.000181569 30.117214 C 0.000181569 46.750842 13.484232 60.234892 30.116623 60.234892 C 46.750251 60.234892 60.234301 46.750842 60.234301 30.117214 C 60.234301 13.483586 46.750251 -0.00046462 30.116623 -0.00046462 ",
    stroke: "#397da2",
    strokeWidth: 8.990535,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(3.164327, 0, 0, 3.17, 224.8642, 228.436357)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 2.499501 2.500607 L 58.618272 2.500607 ",
    stroke: "#397da2",
    strokeWidth: 5,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(3.153961, 0.0741539, -0.0745104, 3.169125, 445.655717, 364.792912)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 2.500366 2.500381 L 23.630785 2.500225 ",
    stroke: "#397da2",
    strokeWidth: 5,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(3.191534, 0.000000000000008302, -0.000000000000008246, 3.17, 445.196525, 289.416977)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 2.500132 2.500559 L 41.207269 2.500559 ",
    stroke: "#397da2",
    strokeWidth: 5,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(3.153961, 0.0741539, -0.0745104, 3.169125, 322.196706, 317.069594)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 2.49976 2.500604 L 23.630179 2.500448 ",
    stroke: "#397da2",
    strokeWidth: 5,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(3.153961, 0.0741539, -0.0745104, 3.169125, 335.713523, 563.771296)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 2.500602 2.499801 L 23.631021 2.499645 ",
    stroke: "#397da2",
    strokeWidth: 5,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(3.191534, 0.000000000000008302, -0.000000000000008246, 3.17, 377.496431, 498.899227)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 2.500406 2.499997 L 41.207543 2.499997 ",
    stroke: "#397da2",
    strokeWidth: 5,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketaccelerationgoallogo);
export default __webpack_public_path__ + "static/media/marketaccelerationgoallogo.5a744eeddfc54bb078ac8c5701509fe9.svg";
export { ForwardRef as ReactComponent };